import React from 'react'
import { connect } from 'react-redux'
import { useDrop } from 'react-dnd'
import { styled } from '@mui/material/styles'
import { Fade, Paper } from '@mui/material'
import { Visibility } from '@mui/icons-material'
import classNames from 'classnames'
import ItemTypes from '../../lib/item_types'
import { movingIndex, movePlayerObserver } from '../../lib/move'
import './ToObserver.scss'

const ToObserverPaper = styled(Paper)(
  ({ theme }) => `
  color: ${theme.palette.toObserver.icon};

  &.hover {
    background-color: ${theme.palette.toObserver.hover};
  }
`
)

const Teams = ({ teams }) => {
  const [hover, setHover] = React.useState(false)

  const [, dropRef] = useDrop({
    accept: ItemTypes.PLAYER,
    collect: (monitor, _props) => {
      const item = monitor.getItem()
      if (!item) {
        setHover(false)
        return
      }
      setHover(monitor.isOver())
    },
    drop: (item, _monitor) => {
      const [dragTeamIndex, dragPlayerIndex] = movingIndex(item.player)
      if (dragTeamIndex === null) {
        return { moved: false }
      }
      movePlayerObserver(dragTeamIndex, dragPlayerIndex)
      return { moved: true }
    }
  })
  return (
    <Fade in={teams.draggingPlayer !== null}>
      <ToObserverPaper ref={dropRef}
                       className={classNames('drop-observer', { hover })}>
        <Visibility fontSize="large" />
      </ToObserverPaper>
    </Fade>
  )
}

export default connect(
  state => ({
    teams: state.teams
  })
)(Teams)
